const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '黑料爆料团队 7×24 小时值守，从事件发生到内容上线平均不超过 30 分钟。黑料吃瓜不打烊，永远快人一步。',
  },
  {
    id: 2,
    icon: 'ri-stack-line',
    title: '深度合集',
    desc: '每条黑料都不是孤立的。我们为你梳理事件全貌，打造吃瓜黑料合集和黑料吃瓜视频时间线，一页看尽来龙去脉。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '多方验证',
    desc: '不传谣、不造谣是黑料吃瓜网的底线。每条黑料最新爆料发布前都经过交叉验证，不确定的传闻明确标注，让吃瓜群众吃得放心。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              平台特色
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {features.map((f) => (
              <div
                key={f.id}
                className="p-6 bg-background-100 rounded-lg border border-background-200/60 text-center hover:border-primary-200 transition-colors"
              >
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${f.icon} text-xl`}></i>
                </div>
                <h3 className="mt-4 text-base font-bold text-foreground-900 font-heading">
                  {f.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {f.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}